import React from "react";
import "./About.scss";

function About() {
  return <div className="About">About page</div>;
}

export default About;
